import { Outlet, useRouterState } from "@tanstack/react-router";
import { Stack } from "@bookingcom/bui-react";
import { useAuth } from "../hooks/useAuth";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { AirlinePickerHeader } from "../components/AirlinePickerHeader";
import { AirlineGroupPickerHeader } from "../components/AirlineGroupPickerHeader";
import { OnboardingTour } from "../components/OnboardingTour";
import { isFeatureRunning } from "../utils/features";

export function RootComponent() {
  const { isAuthenticated, error } = useAuth();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const showAirlinePicker = !error && (pathname === "/overview" || pathname === "/metrics");
  const useAggregatedSelector = isFeatureRunning("FLIGHTS_PARTNER_STRATEGY_MANAGER_AGGREGATED_AIRLINE_PERFORMANCE");

  const showOnBoardingTour = !error && isAuthenticated;

  return (
    <Stack direction="column" gap={0} mixin={{ minHeight: "100vh" }}>
      <Header />
      <Stack gap={0} tagName="main" grow>
        {showAirlinePicker && (useAggregatedSelector ? <AirlineGroupPickerHeader /> : <AirlinePickerHeader />)}
        <Outlet />
      </Stack>
      <Footer />
      {showOnBoardingTour && <OnboardingTour />}
    </Stack>
  );
}
